import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { TestimonialsService } from './../services/testimonials.service';
import { Testimonial } from 'src/libs-common/models/testimonial.model';

@Component({
  selector: 'testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  testimonials$?: Observable<Testimonial[]>;

  constructor(private testimonialsService: TestimonialsService) { }

  ngOnInit(): void {
    this.testimonials$ = this.testimonialsService.getTestimonials()
  }

}
